/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Animalfirstnamerequired4Inputs */

const en_newpatient_animalfirstnamerequired4 = /** @type {(inputs: Newpatient_Animalfirstnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your pet's name.`)
};

const fr_newpatient_animalfirstnamerequired4 = /** @type {(inputs: Newpatient_Animalfirstnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer le nom de votre animal.`)
};

/**
* | output |
* | --- |
* | "Please enter your pet's name." |
*
* @param {Newpatient_Animalfirstnamerequired4Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_animalfirstnamerequired4 = /** @type {((inputs?: Newpatient_Animalfirstnamerequired4Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Animalfirstnamerequired4Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_animalfirstnamerequired4(inputs)
	return fr_newpatient_animalfirstnamerequired4(inputs)
});
export { newpatient_animalfirstnamerequired4 as "newPatient_animalFirstNameRequired" }